/* eslint-disable no-unused-vars */
import React, { useRef, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import CustomCheckbox from "../../atoms/CustomCheckbox";
import Buttons from "../../atoms/Buttons";
import "./declaration.scss";
import { RA_STEPS_IDENTIFIERS } from "../../constants/constants";
import Confetti from "canvas-confetti";
import { ModalOverlay } from "../../atoms/Modal";
import { useNavigate } from "react-router-dom";

const Declaration = (props) => {
  const [isHovered, setIsHovered] = useState(false);
  const [raSuccessShow, setRaSuccessShow] = useState(false);
  const [whatToExpectPopup, setWhatToExpectPopup] = useState(false);
  const [readAll, setReadAll] = useState(false);
  const [risk, setRisk] = useState(false);
  const [recommends, setRecommends] = useState(false);
  const [monetory, setMonetory] = useState(false);
  const [allStatement, setAllStatement] = useState(false);
  const [taxableCheck, setTaxableCheck] = useState(false);
  const hasExitedEarlyRef = useRef(false);
  const navigate = useNavigate();

  const handleClick = () => {
    Confetti({
      particleCount: 1000,
      startVelocity: 80,
      angle: 360,
      spread: 360,
      colors: ["#41e2ba"],
      shapes: ["square"],
      scalar: 1.5,
      duration: 1000,
      zIndex: 9990,
      origin: {
        x: Math.random() - 0,
        y: Math.random() - 0,
      },
    });
  };

  const handleMouseEnter = () => {
    setIsHovered(true);
  };
  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const handleBack = () => {
    props.makeInitialStepper(false, 62, { isConfirmDeclaration: true }, true);
  };

  const handleContinue = () => {
    let declaration = {
      readAll: readAll,
      risk: risk,
      recommends: recommends,
      monetory: monetory,
      allStatement: allStatement,
      readRecyclingRules: taxableCheck,
    };
    props.nextStepIndentifier(RA_STEPS_IDENTIFIERS.RA_CONFIRM_DETAILS, {
      declaration,
    });
    setTimeout(() => {
      if (!hasExitedEarlyRef.current) {
        props.nextStepIndentifier(
          RA_STEPS_IDENTIFIERS.RA_APPLICATION_SUCCESS // eslint-disable-line
        );
        navigate("/");
      }
    }, 30000);
  };

  const isDisabled =
    readAll && risk && recommends && monetory && allStatement && taxableCheck
      ? false
      : true;
  return (
    <>
      <Card className="application-step">
        <Card.Body className="declaration">
          <Row>
            <Col md={12} className="mb-fourty">
              <p className="guidance _title">Your declarations</p>
            </Col>
          </Row>
          <Row className="ourter-bg">
            <div className="checkbox-wrapper">
              <CustomCheckbox
                name="declarationRead"
                variantName="custom-checkbox"
                onChange={() => {
                  setReadAll(true);
                }}
              />
              <div className="me-4">
                <span className="text-bold">I have read all information</span>{" "}
                provided throughout this application process and I am happy to
                go ahead with my choices.
              </div>
            </div>
            <div className="checkbox-wrapper">
              <CustomCheckbox
                name="declarationRisk"
                variantName="custom-checkbox"
                onChange={() => {
                  setRisk(true);
                }}
              />
              <div className="me-4">
                <span className="text-bold">
                  I have read the risk warnings at{" "}
                  <a
                    href="https://tpt.co.uk/risk-warnings"
                    target="_blank"
                    rel="noreferrer"
                    className="risk-warnings-link"
                  >
                    tpt.co.uk/risk-warnings
                  </a>
                </span>{" "}
                and I wish to go ahead with the options selected.
              </div>
            </div>
            <div className="checkbox-wrapper">
              <CustomCheckbox
                name="declarationRecomends"
                variantName="custom-checkbox"
                onChange={() => {
                  setRecommends(true);
                }}
              />
              <div className="me-4">
                I understand that{" "}
                <span className="text-bold">
                  TPT recommends that I take independent financial advice
                </span>{" "}
                from an authorized provider.
              </div>
            </div>
            <div className="checkbox-wrapper">
              <CustomCheckbox
                name="declarationMonetory"
                variantName="custom-checkbox"
                onChange={() => {
                  setMonetory(true);
                }}
              />
              <div className="me-4">
                I understand that the monetary value of{" "}
                <span className="text-bold">
                  my pension can change depending on market performance
                </span>{" "}
                and the values in this application are not guaranteed.
              </div>
            </div>
            <div className="checkbox-wrapper">
              <CustomCheckbox
                name="declarationTaxable"
                variantName="custom-checkbox"
                onChange={() => {
                  setTaxableCheck(true);
                }}
              />
              <div className="me-4">
                I do not intend to use my tax-free lump sum to exceed tax-free
                cash recycling rules regarding use of these funds to contribute
                to a UK pension scheme.
              </div>
            </div>
          </Row>

          <div className="hr"></div>
          <div className="declaration-title">Consent and understanding</div>

          <div className="consent-container">
            <p className="consent">
              {" "}
              My answers are complete, correct and true to the best of my
              knowledge.
            </p>
            <p className="consent">
              I understand the long-term impact of my decisions and that my
              pension choice is irreversible.
            </p>
            <p className="consent">
              I understand that if I select a TPT drawdown account, a new pot
              will be established for each membership that I retire with. I
              could have chosen to combine my TPT pots first and then restart
              this application.
            </p>
            <p className="consent">
              I authorise you to pay my pension and any lump sum into the bank
              or building society account in this application, and that this
              account replaces any existing bank instruction.
            </p>
            <div className="checkbox-wrapper mt-4">
              <CustomCheckbox
                name="declarationAllStatement"
                variantName="custom-checkbox"
                onChange={() => {
                  setAllStatement(true);
                }}
              />
              <div className="me-4">
                <span className="text-bold">
                  I confirm that all statements above are correct
                </span>
              </div>
            </div>
          </div>

          <div className="submission_container">
            <div className="confirm_sub"> Confirm submission</div>
            <div className="confirm_sub_details">
              You are about to submit your retirement application.
              <span className="text-bold">
                {" "}
                Once confirmed, this cannot be undone.
              </span>{" "}
              Are you sure you wish to continue?
            </div>
            <div className="sub_btn">
              <Buttons
                className={"primary submit_application d-flex "}
                variantname="icon-sixteen-px"
                name={"Submit Application"}
                handleClick={() => {
                  setRaSuccessShow(true);
                  handleClick();
                  handleContinue();
                }}
                iconname={
                  !isDisabled
                    ? isHovered
                      ? "arrow-right"
                      : "arrow-right-white"
                    : "arrow-right"
                }
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                disabled={isDisabled}
              />
            </div>
          </div>

          <div className="footer-btn-container">
            <Buttons
              handleClick={handleBack}
              className="secondary back-btn"
              name="Back"
            />
          </div>
        </Card.Body>
      </Card>
      <ModalOverlay
        popup="RetirementApplicationSuccessModal"
        show={raSuccessShow}
        txtStyle="text-center"
        iconTik="icons-tick"
        headTitle="Success!"
        description="Thank you for submitting your retirement application. We’ll process it as soon as possible."
        descriptionOne="While payments can often be made within 7 working days, we might need to wait for some information before we can begin, such as your date of leaving from your employer. We’ll be in touch if we require any more information from you, such as your annuity provider details or additional security checks."
        subDescription="We’re pleased to have supported you in saving for your life beyond work and look forward to assisting you in the future."
        btnUserOtherName="What to expect"
        btnContinuedName="Return home"
        handleTimeline={() => {
          setWhatToExpectPopup(true);
        }}
        handleClick={() => {
          props.nextStepIndentifier(
            RA_STEPS_IDENTIFIERS.RA_APPLICATION_SUCCESS // eslint-disable-line
          );
          hasExitedEarlyRef.current = true;
          setRaSuccessShow(false);
          setWhatToExpectPopup(false);
          navigate("/");
        }}
        onHide={(e) => {
          if (e !== undefined) {
            e.preventDefault();
          }
          props.nextStepIndentifier(
            RA_STEPS_IDENTIFIERS.RA_APPLICATION_SUCCESS //eslint-disable-line
          );
          hasExitedEarlyRef.current = true;
          setRaSuccessShow(false);
          setWhatToExpectPopup(false);
          navigate("/");
        }}
      />
      <ModalOverlay
        popup="whatToExpect"
        show={whatToExpectPopup}
        onHide={(e) => {
          if (e !== undefined) {
            e.preventDefault();
          }
          setWhatToExpectPopup(false);
        }}
      />
    </>
  );
};
export default Declaration;
